import { useApiCommunicator } from '@btcdirect/shared/src/composables/api/communicator';
import { Endpoints } from '@btcdirect/shared/src/composables/api/endpoints';
import { ClientInfo, useClientInfoStore } from '@btcdirect/stores';

export default async function getClientInfo(): Promise<void> {
    const { get } = useApiCommunicator(Endpoints.CLIENT_INFO);

    try {
        const clientInfo: ClientInfo = await get();

        const clientInfoStore = useClientInfoStore();
        clientInfoStore.setClientInfo(clientInfo);
    } catch (exception) {
        throw exception;
    }
}
